import { renderRoutes } from "utils/route";
import { useAuth } from "pages/Auth/hooks";
import { useHistory } from "react-router";
import React, { Suspense, useEffect } from "react";
import PageLoading from "components/base/PageLoading";

interface IProps {
  children?: any;
  route: any;
}

const PublicLayout = (props: IProps) => {
  const { auth } = useAuth();

  const { replace } = useHistory();

  useEffect(() => {
    if (auth) {
      const urlParams = new URLSearchParams(window.location.search);
      const redirectUrl = urlParams.get("redirect");
      replace(redirectUrl || "/");
    }
  }, [auth, replace]);

  const { route } = props;
  return <>{renderRoutes(route.routes)}</>;
};

export default PublicLayout;
